import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'

import axios from "axios";
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchMinus, faSearchPlus,
    faArrowUp, faArrowDown, faArrowLeft, faArrowRight,
    faSearch, faAngleUp, faAngleDown, faTimes } from '@fortawesome/free-solid-svg-icons';
    
import './nlp/nlp.css';
import './nlp/hierarchy-select.min.css';
import './nlp/videolang.css';
import transcript from './nlp/videotrackannotate_adl_1.js';
import frm from './formAux.js'

function valueIn( v, list ) {
    return list.indexOf(v) != -1;
}



/*
https://labeling-datasets.s3.ap-south-1.amazonaws.com/output/Home-Appliance-Job-3/manifests/output/output.manifest
s3://labeling-datasets/output/kitti-bounding-box-audit/manifests/output/output.manifest
*/

function taskNav()
{
    var tlist = window.GlobalVars.taskList;
    var tname = 'Task'
    if( datasetDetail ) {
        $('.top-nav').html('<button class="wizz1">Back to Dataset</button>');
        // $('.top-nav').remove();
        // return;
        tlist = window.GlobalVars.itemList;
        tname = 'Item';
        $('.top-nav').find('button').on('click', function(){
            window.goPage('datasetItems');
        })
    }
    if( !tlist ) return;
    var nav = $('<div class="task-spacer"></div><div class="task-nav"><i class="fa fa-step-backward first"></i><i class="fa fa-backward prev"></i><span class="task-pos"></span><i class="fa fa-forward next"></i><i class="fa fa-step-forward last"></i></div>');
    if( $('.top-nav').html() == '')$('.top-nav').append( $('<button>') );
    $('.top-nav').append( nav );
    
    var len = tlist.list.length;
    var pos = tlist.idx+1;
    $('.task-pos').text( tname + ' '+pos+' of '+len );  // modifytask to Task 22/12 mani
    nav.find('I').on('click', function(){
        var npos = 0;
        if( $(this).hasClass('prev') ) npos = pos-2;
        else if( $(this).hasClass('next') ) npos = pos;
        else if( $(this).hasClass('last') ) npos = len-1;
        if( npos < 0 ) npos = 0;
        var nextFile = null;
        // if( tlist.list[npos] ) nextFile = tlist.list[npos].fileId;
        // alert( npos )
        if( tlist.list[npos] ) nextFile = tlist.list[npos];
        if( nextFile )
        {
            var params = window.getParams();
            if( datasetDetail ) {
                params.itemId = nextFile;
                delete params.fileId;
                delete window.GlobalVars.PDFFileId;
                window.GlobalVars.PDFItemId = nextFile;
            } else {
                params.fileId = nextFile;
                window.GlobalVars.PDFFileId = nextFile;
            }
            tlist.idx = npos;
            window.saveSession( function(){
                window.goPage( window.getPage(1), params ) 
            } );
            return;
        }
        window.saveSession();
        window.goPage(backPage,window.getParams())
    })
}


var backPage = 'nlpBrowse';
var submitted = false;
var resumeLaterTid = null;
var datasetDetail = false;

function ViewerTranscription(prop) {
    window.transcript = transcript;
    useEffect( function(a){
        let params = window.getParams();
        if( params.ptype == 'datasetDetail') {
            datasetDetail = true;
        }
        if( window.GlobalVars.PDFRole ) backPage = 'nlpJobs';
        window.setNavActive(backPage);
        var fileId = window.GlobalVars.PDFFileId;
        var itemId = fileId ? null : window.GlobalVars.PDFItemId;

        // var myId = window.GlobalVars.userId || window.GlobalVars.workerId;
        var myId = window.GlobalVars.userId;
        var myEmail = window.GlobalVars.userEmail;


        function resumeLater() {
            console.log( 'resumeLater', transcript.updating() )
            clearTimeout( resumeLaterTid )
            if( !transcript.updating() ) {
                setTimeout( function(){window.goPage(backPage);}, 500 );
            }
            else resumeLaterTid = setTimeout( resumeLater, 500 );
        }
        $('#resumeLater').off('click').on('click', function(){
            if( deepLinkResult() ) return;
            resumeLater();
        });                                                         
                                                    
        function deepLinkResult() {
            if( window.GlobalVars.deepLinkReturnURL ) {
                var a = $('<a target="_top">').attr('href', window.GlobalVars.deepLinkReturnURL );
                $(document.body).append(a);
                a[0].click();
                return true;
            } 
            return false;
        }


        function submitAnnotations( obj )
        {
            if( submitted ) return;
            submitted = true;

            console.log( 'SUBMIT', obj )
            window.post( 'save_annotation', {
                fileId:fileId,
                myId:myId,
                annotations:obj,
                target:'final',
                role:window.GlobalVars.PDFRole
            }, function(res){
                if( window.GlobalVars.taskList )
                {
                    var tlist = window.GlobalVars.taskList;
                    // if( tlist.list[tlist.idx+1] ) tlist.next = tlist.list[tlist.idx+1].fileId;
                    if( tlist.list[tlist.idx+1] ) tlist.next = tlist.list[tlist.idx+1];
                    else tlist.next = 'next';
                    window.saveSession();
                }

                window.goPage(backPage)
                console.log( 'submited' );
            });
        }

        function updateAnnotations( obj, callback )
        {
            console.log( 'UPDATE', obj );

            window.post( 'save_annotation', {
                fileId:fileId,
                myId:myId,
                myEmail:myEmail,
                annotations:obj,
                target:'tmp',
                role:window.GlobalVars.PDFRole
            }, function(res){
                console.log( 'updated' );
                if( callback ) callback(res);
            });
        }

        var claimWait = false;
        function claimCallback(descriptor) {
            descriptor.task_auto_claim = false;
            if (claimWait) return;

            claimWait = true;
            window.post('claim_task', { fileId: fileId }, function (res) {
                console.log('CLAIM', res.data)
                if (!res.data) {
                    return frm.myAlert('Claim Error', "You cant't claim this task")
                }
                if (descriptor.task_orig_state > 1 && descriptor.task_orig_state != 7 && !descriptor.disableQC) {
                    descriptor.reviewMode = 1;
                }
                descriptor.blockEdit = false;
                descriptor.fixButtons(descriptor);
                $('.mode-select').show();
                $('.segmentation').show();
                $('.video-toolbar').css({height:''});
                if( descriptor.currentMode ) descriptor.waveMode( descriptor.currentMode.id,true)
                claimWait = false;
            });
        }

        function releaseCallback(descriptor) {
            frm.myAlert('Release Task', "By releasing the task, any temporary annotations you've made will be lost. Are you sure?", "Ok", release, "Cancel");
            function release() {
                window.post('release_task', { fileId: fileId, myId: myId }, function (res) {
                    console.log('RELEASE', res.data, descriptor)
                    if (!res.data) {
                        return frm.myAlert('Release Error', "You cant't release this task")
                    }
                    if (descriptor.task_orig_state > 1) {
                        descriptor.reviewMode = false;
                    }
                    descriptor.blockEdit = true;
                    descriptor.task_can_claim = true;
                    descriptor.fixButtons(descriptor);
                    window.goPage(backPage,window.getParams());
                })
            }
        }


        // var modal = $('<div id="myModal" class="modal fade" role="dialog" style="z-index: 100000">').html('<div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close myclose" data-dismiss="modal">&times;</button><h4 class="modal-title">Modal Header</h4></div><div class="modal-body"><p>Some text in the modal.</p></div><div class="modal-footer"><button type="button" id="modal-close" class="btn btn-secondary" data-dismiss="modal">Close</button><button type="button" id="modal-close2" class="btn btn-secondary" data-dismiss="modal">Close</button><button type="button" id="modal-close3" class="btn btn-secondary" data-dismiss="modal">Close</button></div></div></div>');
        // $(document.body).prepend(modal);
        console.log( 'LOADFILE', {fileId:fileId,myId:myId, itemId:itemId} )

        setTimeout( taskNav, 1 );
        window.post( 'load_file', {fileId:fileId,myId:myId,itemId:itemId}, function(res){
            console.log( 'LOAD_FILE', res.data );
            var file = res.data;
            let title = 'Project: <span>' + file.projectName + '</span>';
            const truncateWords = (str, n) => str?.length > n ? str.slice(0, n) + "..." : str;
            if( !file.projectName ) title = 'Dataset Item: <span>'+truncateWords(file.name, 30)+'</span>'
            $('#pageTitle').html(title);

            var descriptor = file.descriptor;

            var url = file.adlUrl || file.signedUrl;
            if( url.match(/localhost/) ) url = url.replace( /localhost/, document.location.hostname );
            if( file.type.match(/audio/))
                descriptor.audioSource = url;
            else
                descriptor.videoSource = url;

            var deskMeta = descriptor;
            console.log('desk', deskMeta)
            if( !deskMeta.media ) { 
                deskMeta.media = {};
                deskMeta.media.metadata = {};
            }
            if( file.name ) deskMeta.media.metadata.File = file.name;
            // if( window.hasPriv( 'admin', 'c_admin', 'c_super') ) 
            if( file.fileId ) deskMeta.media.metadata.TaskId = file.fileId;
            else if( file.itemId ) deskMeta.media.metadata.ItemId = file.itemId;
            if( file.metadata ) for( var m in file.metadata ) deskMeta.media.metadata[m] = file.metadata[m];

            let videoMetadata = $('#mediaMetaData');
            // videoMetadata.hide();
            var out = [];
            for( var k in deskMeta.media.metadata )
            {
                out.push('<b>'+k+':</b>');
                out.push(deskMeta.media.metadata[k]);
                out.push('&nbsp;');
            }
            var htmlJoin = out.join(' ');
            videoMetadata.html(htmlJoin).show();

            videoMetadata.attr('title',videoMetadata.text()).off('click').on('click', function(ev) {
                if( ev.ctrlKey ){
                    if( deskMeta.media.metadata.TaskId ) {
                        var md = deskMeta.media.metadata.TaskId;
                        var msg = 'Task Id Saved to clipboard';
                    }
                    else if( deskMeta.media.metadata.ItemId ) {
                        var md = deskMeta.media.metadata.ItemId;
                        var msg = 'Dataset Item Id Saved to clipboard';
                    }
                }
                else {
                    var md = JSON.stringify(deskMeta.media.metadata,null,'\t');
                    var msg = 'The task matadata was copied to the clipboard';
                }
                saveClipboard( md );
                frm.myAlert('Metadata Copied', msg, 'Ok')
                setTimeout( function(){
                    $("#modal-close")[0].click();
                }, 3000  )
            })

            function saveClipboard( txt )
            {
                function px(v) { return v+'px'; }
                var input = $('<textarea>').val(txt).css({position:'absolute',top:px(-10000),left:px(-100000)});
                $(document.body).append(input);
                input.select();
                // input.setSelectionRange(0, 99999999);
                document.execCommand("copy");
                setTimeout( function(){
                    input.remove();
                }, 100 );
            }

            var loadfrom = file.myAnnotations || file.annotations;
            if( loadfrom )
            {
                ['streams', 'mediaAttributes','review','elapsedTime','jobStart'].forEach( l => {
                    if( loadfrom[l] ) descriptor[l] = loadfrom[l];
                });
            }
            // descriptor.messages = [];
            if( file.messages && file.messages.length ) descriptor.messages = file.messages;
            // descriptor.transcriptionMode = true;
            descriptor.reviewMode = file.state == 3;
            descriptor.reviewMayRequestAdjustment = file.userEmail > '' && descriptor.qcMayRequestAdjustment;
            descriptor.task_can_decline = true;
            descriptor.videoAudioSource = file.audioSource || null;

            // descriptor.submit = submitAnnotations;
            // descriptor.update = updateAnnotations;
            // claim-release stuff
            // descriptor.task_can_claim = (descriptor.fullListMode || false) && (file.state == 0 || file.state==2);
            descriptor.task_can_claim = (
                (valueIn(file.state, [0, 2, 4, 5, 7, 8]) && window.hasPriv('admin', 'c_admin', 'c_super')) ||
                (file.state == 0 && window.hasPriv('nlp_an')) ||
                (file.state == 2 && window.hasPriv('nlp_qc'))
            );
            descriptor.task_can_release = (descriptor.fullListMode || false);
            if (descriptor.task_can_release) {
                if (file.userEmail == window.GlobalVars.userEmail && file.state > 1) descriptor.task_can_release = false;
                else if (file.qcEmail == window.GlobalVars.userEmail && file.state < 2) descriptor.task_can_release = false;
            }
            if (datasetDetail) {
                descriptor.task_can_claim = descriptor.task_can_release = false;
                descriptor.blockEdit = true;
            }
            descriptor.task_orig_state = file.state;
            descriptor.task_role = valueIn(file.state, [0, 1, 6, 7]) || descriptor.disableQC ? 'Annotator' : 'Reviewer';

            try {
                var role = window.GlobalVars.PDFRole || 'nlp_an';
                var emailcheck = file.state >= 2 && file.state <= 3 ? 'qcEmail' : 'userEmail';
                var currEmail = file[emailcheck][file[emailcheck].length - 1]
                descriptor.blockEdit = currEmail != window.GlobalVars.userEmail;
                if ([0, 1, 2, 3, 6].indexOf(file.state) == -1) descriptor.blockEdit = true;
            }
            catch (e) { }

            if (descriptor.task_can_claim && window.deeplink) descriptor.task_auto_claim = true;
            descriptor.submit = submitAnnotations;
            descriptor.update = updateAnnotations;
            descriptor.claimCallback = claimCallback;
            descriptor.releaseCallback = releaseCallback;
            // claim-release stuff end


            if (datasetDetail) {
                descriptor.task_can_claim = descriptor.task_can_release = false;
                descriptor.datasetDetail = true;
                descriptor.blockEdit = true;
                if( !file.fileId ) {
                    $('.mode-select').hide();
                    $('.video-toolbar').css({height:10})
                }
                $('#submitBox').hide();
                $('#chatbox').hide();
            }
            console.log( 'descriptor', window.clone(descriptor) );
            window.setTimeout( function(){ console.log('')}, 10 );
            var tid = window.setTimeout( function(){transcript.start(descriptor);}, 100 );
            console.log( 'tid', tid )
        });
    },[]);

    return (
 <main id="maincolumn" role="main" className="maincontent">


	<div className="container-fluid">
        <div className="row video-toolbar">
            <div className="col-12">
                <div className="video-toolbar-content mode-select"></div>
                  {/*added chatbox mani */}
                  <span id="chatbox" className="cckbutton adjcheck tool-button" title="">
                        <span><img className=" " src="imgs/chat.svg" /></span>
                        <div id="chat_notification" className="notification"></div>
                    </span> 
                <div className="mt-2 video-toolbar-content" id="submitBox">
                <button id="submitButton" type="submit" className="mt-2 btn btn-pink hidden"> <i class=" mr-2 fa fa-check-circle-o" aria-hidden="true"></i>Submit </button>{/*modify submit Annotation as Submit mani */}
                <button id="resumeLater" type="submit" className="mt-2 btn btn-pink hidden"> <i class=" mr-2 fa fa-floppy-o" aria-hidden="true"></i>Save & Exit</button>{/*modify Resume Later as save and Exit mani */}
                </div>
                <div className="col-9 video-metadata media-metadata" id="mediaMetaData"></div>
            </div>
        </div>
        <div className="row">
            <div className="col-6 waveinterface mt-lg-5">
                <div className="row">
                    <div className="col-12">
                        <div id="imgtitle" className="text-center"></div>
                    </div>
                </div>
                <div id="videopanel" className="videopanel centered text-center">
                    <div id="videowraper">
                        <video id="video" pposter="" data-ckin="default" data-overlay="0" ddata-title=""></video>
                        <div id="subtitles"></div>
                    </div>
                </div>
                <div className="segmentation"></div>
                <div className="wavecontainer">
                    <div id="waveformindex"></div>
                    <div id="waveform"></div>
                </div>
                <audio id="audio" pposter="" data-ckin="default" data-overlay="0" ddata-title="" className="mb-5"></audio>

            </div>
            <div id="t_right" className="col-6 ctrlpanel" style={{height: '50%', overflowY:"auto"}}>
                <div id="messages" className="file-messages"></div>
                <div id="reviewer_rate_div">
                    <select className="mmdb-select mmd-form iselect" id="reviewer_rate">
                        <option value="">Are the Annotations Ok?</option>
                        <option value="Ok">Annotations are OK</option>
                        <option value="Rejected">Reject Annotations</option>
                        <option id="optadjust" value="Adjust">Request Adjustments</option>
                    </select>
                </div>
                <div className="mt-2" id="submit">
                    <div id="reviewer-fields" className="hidden-obj">
                        <textarea id="reviewer_notes" className="inote-text mt-2" placeholder="Reviewer Notes"></textarea>
                    </div>
                    <textarea id="annotator_notes" className="inote-text mt-2" placeholder="Annotator Notes"></textarea>
                </div>

                <div id="right1" className="nothing">
                    <div className="mt-2 hidden" id="prevnextBox">
                        <div className="text-question" id="questionTitle"></div>
                        <div id="questionAnswer" placeholder="your answer" className="text-answer"></div>
                        <div id="questionInstructions" className="text-instructions"></div>
                        <div id="questionFalse"></div>
                        <textarea id="questionUserAnswer" className="inote-text" placeholder="Enter correct answer"></textarea>
                        <button id="buttonPrev" type="submit" className="mt-2 btn btn-primary prevnext">Prev</button>
                        <div className="prevnext_number"><span></span></div>
                        <button id="buttonNext" type="submit" className="mt-2 btn btn-primary prevnext">Next</button>
                    </div>
                </div>
                <div id="reportpanel"></div>
                <div id="right2" className="nothing">
                    <div className="hierarchy"></div>
                    <div id="video-attr">
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
    )
}

export default ViewerTranscription
